import { CSS, makeInputStyle, StyleProps } from "@shared/primitive-components"

export const styledInputContainer = (props: StyleProps): CSS => ({
  width: `100%`,
  ...makeInputStyle(props),
  position: `relative`,
  alignItems: `center`,
})
